// extracted by mini-css-extract-plugin
export default {"section":"Layout_section__o2h2c","container":"Layout_container__KqXG3","container--sm":"Layout_container--sm__tIGa5","container--md":"Layout_container--md__smXKX"};